// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "KentuckyFriedSerif-Regular";
  src: url('KentuckyFriedSerif-Regular.ttf') format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "KentuckyFriedSerif-Italic";
  src: url('KentuckyFriedSerif-Italic.ttf') format("truetype");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "National2Condensed-XBold";
  src: url('National2Condensed-XBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
body {
  font-family: "KentuckyFriedSerif-Regular";
  font-size: 1rem;
  color: #ffffff;
  line-height: 1.6;
}

.btn {
  font-family: "National2Condensed-XBold";
  background-color: #fff;
  color: #000;
  border-color: #fff;
}

.h1, h1 {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.1;
}

.h2, h2 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.15;
}

.h3, h3 {
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.2;
}

.h4, h4 {
  font-size: clamp(1.5rem, 2.5vw, 1.875rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.25;
}

.h5, h5 {
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.3;
}

.h6, h6 {
  font-size: clamp(1.1rem, 1.5vw, 1.25rem);
  font-family: "National2Condensed-XBold";
  line-height: 1.35;
  text-transform: uppercase;
}

a {
  color: #fff;
}
a:hover {
  color: #fff;
}

.bold {
  font-family: "National2-Bold";
}

.calendar .tile {
  font-family: "National2Condensed-XBold";
}

header nav .navbar-collapse ul.navbar-nav li.nav-item a.nav-link {
  font-family: "National2Condensed-XBold";
}

.error-message {
  font-family: "National2-Regular";
}

.footer-graphic {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

section.footer {
  background-color: #f4002c;
  text-align: center;
  color: #ffffff;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
section.footer a {
  color: #ffffff;
  padding: 0 1rem;
  text-decoration: none;
  font-family: "KentuckyFriedSerif-Italic";
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/typography.scss","webpack://./src/app/modules/page-layout/footer/footer.component.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAKA;EACE,yCAAA;EACA,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ACJF;ADMA;EACE,wCAAA;EACA,4DAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACJF;ADMA;EACE,uCAAA;EACA,0DAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACJF;ADSA;EACE,yCAAA;EACA,eAAA;EACA,cExBU;EFyBV,gBAAA;ACPF;;ADUA;EACE,uCAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;ACPF;;ADUA;EAAU,qCAAA;EAAuC,uCAAA;EAAyC,gBAAA;ACJ1F;;ADKA;EAAU,oCAAA;EAAsC,uCAAA;EAAyC,iBAAA;ACCzF;;ADAA;EAAU,uCAAA;EAAyC,uCAAA;EAAyC,gBAAA;ACM5F;;ADLA;EAAU,yCAAA;EAA2C,uCAAA;EAAyC,iBAAA;ACW9F;;ADVA;EAAU,sCAAA;EAAwC,uCAAA;EAAyC,gBAAA;ACgB3F;;ADfA;EAAU,wCAAA;EAA0C,uCAAA;EAAyC,iBAAA;EAAmB,yBAAA;ACsBhH;;ADpBA;EACE,WAAA;ACuBF;ADrBE;EACE,WAAA;ACuBJ;;ADpBA;EACE,6BAAA;ACuBF;;ADnBE;EACE,uCAAA;ACsBJ;;ADbU;EACE,uCAAA;ACgBZ;;ADRA;EACE,gCAAA;ACWF;;AAzFA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AA4FJ;;AAtFA;EACI,yBCTO;EDUP,kBAAA;EACA,cCTI;EDUJ,iBAAA;EACA,oBAAA;AAyFJ;AAvFI;EACI,cCdA;EDeA,eAAA;EACA,qBAAA;EACA,wCDGU;ACsFlB","sourcesContent":["@use './colors' as colors;\n@use './bootstrap-essentials' as bootstrap;\n\n\n\n@font-face {\n  font-family: 'KentuckyFriedSerif-Regular';\n  src: url('../fonts/KentuckyFriedSerif-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'KentuckyFriedSerif-Italic';\n  src: url('../fonts/KentuckyFriedSerif-Italic.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'National2Condensed-XBold';\n  src: url('../fonts/National2Condensed-XBold.woff2') format('woff2');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n$regular-italics: 'KentuckyFriedSerif-Italic';\n\nbody {\n  font-family: 'KentuckyFriedSerif-Regular';\n  font-size: 1rem;\n  color: colors.$body-text;\n  line-height: 1.6;\n}\n\n.btn {\n  font-family: 'National2Condensed-XBold';\n  background-color: #fff;\n  color: #000;\n  border-color: #fff;\n}\n\n.h1, h1 { font-size: clamp(2.5rem, 5vw, 3.5rem); font-family: 'National2Condensed-XBold'; line-height: 1.1; }\n.h2, h2 { font-size: clamp(2rem, 4vw, 2.75rem); font-family: 'National2Condensed-XBold'; line-height: 1.15; }\n.h3, h3 { font-size: clamp(1.75rem, 3vw, 2.25rem); font-family: 'National2Condensed-XBold'; line-height: 1.2; }\n.h4, h4 { font-size: clamp(1.5rem, 2.5vw, 1.875rem); font-family: 'National2Condensed-XBold'; line-height: 1.25; }\n.h5, h5 { font-size: clamp(1.25rem, 2vw, 1.5rem); font-family: 'National2Condensed-XBold'; line-height: 1.3; }\n.h6, h6 { font-size: clamp(1.1rem, 1.5vw, 1.25rem); font-family: 'National2Condensed-XBold'; line-height: 1.35; text-transform: uppercase; }\n\na {\n  color: #fff;\n\n  &:hover {\n    color: #fff;\n  }\n}\n.bold{\n  font-family: 'National2-Bold';\n\n}\n.calendar{\n  .tile{\n    font-family: 'National2Condensed-XBold';\n  }\n}\n\nheader {\n  nav {\n    .navbar-collapse {\n      ul.navbar-nav {\n        li.nav-item {\n          a.nav-link {\n            font-family: 'National2Condensed-XBold';\n          }\n        }\n      }\n    }\n  }\n}\n\n.error-message {\n  font-family: 'National2-Regular';\n}","@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/typography' as fonts;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n.footer-graphic{\n    display: block;\n    max-width: 100%;\n    margin: 0 auto;\n    //filter: drop-shadow(-2px 15px 40px rgba(0, 0, 0, 1.0));\n    //-webkit-clip-path: inset(-120px -120px 0 -120px);\n    //clip-path: inset(-120px -120px 0 -120px);\n}\n\nsection.footer{\n    background-color: colors.$brand-bg;\n    text-align: center;\n    color: colors.$white;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n\n    a{\n        color: colors.$white;\n        padding: 0 1rem;\n        text-decoration: none;\n        font-family: fonts.$regular-italics;\n    }\n    // img{\n    //     background-color: colors.$red;\n    // }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n","$brown: #cca374;\n$green: #00823d;\n$light-brown: #eaedd2;\n$yellow: #ffcc00;\n$red: #e5052a;\n$brand-bg: #f4002c;\n$header-bg: #000000;\n$white: #ffffff;\n$body-text: #ffffff;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
